import { cn, copyToClipboard } from "@/lib/utils";
import { useMutation } from "@tanstack/react-query";
import { BiCopy } from "react-icons/bi";
import { Indicator } from "./indicator";
import { Button, ButtonProps } from "./button";
import { useTooltipProps } from "./tooltip";
import { useTranslation } from "react-i18next";
import { IconBaseProps } from "react-icons/lib";

// const copyIconStyle = cva("", {
//   variants: {
//     size: {
//       // default: "",
//       // "2xs": "size-2"

//       default: "size-3",
//       "2xs": "size-2",
//       xs: "size-2.5",
//       sm: "size-3",
//       lg: "size-6",
//       "2xl": "size-10",
//       icon: "size-4",
//       page: "size-3.5",
//     },
//   },
//   defaultVariants: {
//     size: "default",
//   },
// });

export function CopyButton({
  value,
  copyProps,
  ...props
}: ButtonProps & { value: string; copyProps?: IconBaseProps }) {
  const copy = useMutation({
    mutationFn: () => copyToClipboard(value),
  });
  return (
    <Button
      type="button"
      // size={size}
      {...props}
      onClick={(ev) => {
        ev.preventDefault();
        copy.mutateAsync();
      }}
      className={cn("relative h-auto", props.className)}
    >
      <BiCopy {...copyProps} className={cn("size-3.5", copyProps?.className)} />
      {copy.isSuccess && (
        <Indicator
          position={"tr"}
          size={"2xs"}
          border={"none"}
          className="animate-flash opacity-0"
        />
      )}
    </Button>
  );
}

export const CopyLine = ({
  value,
  className,
  children,
  copy,
  ...props
}: { value?: string } & React.HTMLProps<HTMLDivElement> & {
    copy?: ButtonProps;
  }) => {
  const tooltipProps = useTooltipProps();
  const { t } = useTranslation();
  return !value ? undefined : (
    <div {...props} className={cn("flex items-center gap-1", className)}>
      <span>{value}</span>
      <div className="flex items-center ml-auto gap-1">
        {children}
        <CopyButton
          {...tooltipProps}
          data-tooltip-content={t("copyToClipboard")}
          {...copy}
          size={copy?.size ?? "xs"}
          className={cn("ml-auto", copy)}
          value={value}
        />
      </div>
    </div>
  );
};
